import script from "./MenuList.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuList.vue?vue&type=script&setup=true&lang=js"

import "./MenuList.vue?vue&type=style&index=0&id=89983c4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89983c4c"]])

export default __exports__